var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarrierGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:rgba(255,255,255,0.5);}.a{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-78 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(78 228)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 165.936)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 67.064)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,232.757a.361.361,0,0,0,.362.38H.94a2.559,2.559,0,0,1,2.3-1.5,2.56,2.56,0,0,1,2.3,1.5h7.511v-3.073H0Z",
    transform: "translate(0 -221.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32.175,277.32a1.7,1.7,0,1,0,1.7,1.7A1.7,1.7,0,0,0,32.175,277.32Z",
    transform: "translate(-28.937 -266.727)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M281.681,191.777l-1.622-.713H275V196.1h.982a2.508,2.508,0,0,1,4.6,0h.961a.361.361,0,0,0,.362-.38v-3.579A.392.392,0,0,0,281.681,191.777Z",
    transform: "translate(-261.145 -184.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M278.391,121.683a1.157,1.157,0,0,0-1.044-.622H275v2.721h4.48Z",
    transform: "translate(-261.145 -118.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.892,67.064H1.151A1.161,1.161,0,0,0,0,68.245V74.47H13.049V68.245s0,0,0-.005A1.166,1.166,0,0,0,11.892,67.064Z",
    transform: "translate(0 -67.064)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M308.008,277.32a1.7,1.7,0,1,0,1.7,1.7h0A1.7,1.7,0,0,0,308.008,277.32Z",
    transform: "translate(-290.873 -266.727)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrierGray);
export default __webpack_public_path__ + "static/media/carrierGray.faf9519f1e0e0edc6e4b3f2bd2384670.svg";
export { ForwardRef as ReactComponent };